import { render, staticRenderFns } from "./ScoreCharts.vue?vue&type=template&id=0aa77428"
import script from "./ScoreCharts.vue?vue&type=script&lang=js"
export * from "./ScoreCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports